import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-46eed9e2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tabs"
};
const _hoisted_2 = {
  class: "tabs-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["tab", {
      'active': $data.currentTabComponent === $data.tabs[0]
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $data.currentTabComponent = $data.tabs[0])
  }, "Авторы", 2), _createElementVNode("div", {
    class: _normalizeClass(["tab", {
      'active': $data.currentTabComponent === $data.tabs[1]
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $data.currentTabComponent = $data.tabs[1])
  }, "Работы", 2), _createElementVNode("div", {
    class: _normalizeClass(["tab", {
      'active': $data.currentTabComponent === $data.tabs[2]
    }]),
    onClick: _cache[2] || (_cache[2] = $event => $data.currentTabComponent = $data.tabs[2])
  }, "Подборки", 2)]), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent($data.currentTabComponent), {
    class: "tab-content",
    q: $props.q,
    key: $data.currentTabComponent + $data.key
  }, null, 8, ["q"]))], 1024))])], 64);
}